import { getters } from './getters';

export default {
  namespaced: true,
  getters,
};
